import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90bfaf8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = { class: "app-wrapper" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "emq-table-footer" }

import { ref, computed, onMounted } from 'vue'
import { GetRescueConfigList, AddRescueConfig, UpdateRescueConfig } from '@/api/operation'
// 修改这里的colProps配置
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import {Search, RefreshLeft, Refresh, Plus} from '@element-plus/icons-vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { throttleBtn } from '@/common/tools'
import SelectOperator from '@/components/SelectOperator.vue'
import {pick} from "lodash";
import usePaginationRemember from "@/hooks/usePaginationRemember";
import RescueConfigEdit from "@/views/Support/components/RescueConfigEdit.vue";
import RescueConfigCreate from "@/views/Support/components/RescueConfigCreate.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const colProps = {
  xs: 20,
  sm: 10,
  md: 8,
  lg: 6,
  xl: 4
}
const { t } = useI18nTl('Operation')
const { rescueOrderState, paymentModes, rescueType } = useProtocolEnums()

// 过滤掉Unknown状态(值为0)
const filteredRescueOrderState = computed(() => {
  return rescueOrderState.filter(item => item.value !== 0)
})

// 状态映射函数（需根据实际枚举定义补充）
const getRescueOrderStateLabel = (state) => {
  return rescueOrderState.find(item => item.value === state)?.label || "-"
}
const getPaymentModeLabel = (mode) => {
  return paymentModes.find(item => item.value === mode)?.label || "-"
}
const getRescueTypeLabel = (type) => {
  return rescueType.find(item => item.value === type)?.label || "-"
}

// 状态管理
const showCreateDialog = ref(false)
const showEditDialog = ref(false)
const showEditData = ref({})
const tableData = ref([])
const lockTable = ref(false)
const fuzzyParams = ref({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('rescueConfig')

const createConfig = () => {
  showCreateDialog.value = true
}

const editConfig = (row: any) => {
  showEditData.value = row // 使用展开运算符创建新对象
  showEditDialog.value = true
}

// 搜索逻辑
const handleSearch = async () => {
  const params = {
    ...fuzzyParams.value,
    pageReq: pageParams.value
  }
  await loadTables(params)
}
const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

// 加载表格数据
const loadTables = async (params = {}) => {
  lockTable.value = true
  try {
    // 修正参数处理方式
    const queryParams = {
      ...(typeof params === 'object' ? params : {}),
      ...fuzzyParams.value,
      pageReq: {
        ...pageParams.value,
        ...(params.pageReq || {})
      }
    }

    const { list, pageReply } = await GetRescueConfigList(queryParams)
    const meta = toPageMeta(queryParams.pageReq, pageReply)

    tableData.value = list || []
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...fuzzyParams.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

// 修改loadDatasRefreshLimit调用方式
const loadDatasRefreshLimit = throttleBtn(() => {
  return loadTables({
    ...fuzzyParams.value,
    pageReq: pageParams.value
  })
})
onMounted(() => {
  loadTables({...fuzzyParams.value,
    pageReq: pageParams.value})
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(colProps)), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _mergeProps(colProps, { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (createConfig()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
        ]),
        _: 1
      }, 8, ["icon"])), [
        [_directive_role, 'supportRescueConfigOperate']
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        icon: _unref(Refresh),
        onClick: _unref(loadDatasRefreshLimit)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
        ]),
        _: 1
      }, 8, ["icon", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref: "TableCom",
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "100",
            label: _ctx.$t('Base.operatorName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "rescueType",
            "min-width": "120",
            label: _ctx.$t('Operation.rescueType')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(getRescueTypeLabel(row.rescueType)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "needPay",
            "min-width": "80",
            label: _ctx.$t('Operation.needPay')
          }, {
            default: _withCtx(({ row }) => [
              (row.needPay)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Base.yes')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('Base.no')), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "payAmount",
            "min-width": "100",
            label: _ctx.$t('Operation.payAmount')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString((row.payAmount / 100).toFixed(2)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            "min-width": "80",
            label: _ctx.$t('Base.remark')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "120",
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation",
            fixed: "right"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editConfig(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'supportRescueConfigOperate']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[2] || (_cache[2] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTables
        }, null, 8, ["metaData"])
      ]),
      _createVNode(RescueConfigEdit, {
        modelValue: showEditDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showEditDialog).value = $event)),
        data: showEditData.value,
        onSuccess: _unref(loadDatasRefreshLimit)
      }, null, 8, ["modelValue", "data", "onSuccess"]),
      _createVNode(RescueConfigCreate, {
        modelValue: showCreateDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showCreateDialog).value = $event)),
        onSuccess: _unref(loadDatasRefreshLimit)
      }, null, 8, ["modelValue", "onSuccess"])
    ])
  ]))
}
}

})